"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreatePayment_1 = require("./CreatePayment");
exports.CreatePayment = CreatePayment_1.CreatePayment;
var CreatePaymentLine_1 = require("./CreatePaymentLine");
exports.CreatePaymentLine = CreatePaymentLine_1.CreatePaymentLine;
exports.CreateBarcodeValidation = CreatePaymentLine_1.CreateBarcodeValidation;
exports.ValidationLine = CreatePaymentLine_1.ValidationLine;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["INPROGRESS"] = "in progress";
    PaymentStatus["COMPLETED"] = "completed";
    PaymentStatus["CANCELLED"] = "cancelled";
    PaymentStatus["FAILED"] = "failed";
    PaymentStatus["REFUNDED"] = "refunded";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentLineType;
(function (PaymentLineType) {
    PaymentLineType["PRODUCT"] = "product";
    PaymentLineType["DISCOUNT"] = "discount";
    PaymentLineType["LOYALTY"] = "loyalty";
    PaymentLineType["PAYMENT_FEE"] = "paymentFee";
})(PaymentLineType = exports.PaymentLineType || (exports.PaymentLineType = {}));
// The structure of the request the API expects
var ICreatePayment = /** @class */ (function () {
    function ICreatePayment() {
    }
    return ICreatePayment;
}());
exports.ICreatePayment = ICreatePayment;
//# sourceMappingURL=index.js.map